<template>
  <div>
    <div class="flex justify-between">
      <h2
        class="mt-0"
        v-text="'Member Exports'"
      />
      <button
        type="button"
        class="btn--link"
        @click="openAuthCodeModal = true"
        v-text="'Export as CSV'"
      />
    </div>
    <ExportsTable :exports="exports" />
    <AuthCodeModal
      :open="openAuthCodeModal"
      @closeModal="openAuthCodeModal = false"
      @authCodeVerified="authCodeVerified"
    />
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex'
import ExportsTable from 'Export/Resources/assets/js/components/ExportsTable'

export default {
  name: 'ExportMembershipData',
  components: {
    ExportsTable,
  },
  data() {
    return {
      loading: true,
      openAuthCodeModal: false,
    }
  },
  computed: {
    ...mapState({
      exports: state => state.exports.exports.data,
    }),
  },
  mounted() {
    this.getExports({
      params: {
        types: 'export',
      },
    }).then(() => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions({
      exportMembershipData: 'membershipExportMembershipData',
      getExports: 'exportGetExports',
    }),
    authCodeVerified(){
      this.openAuthCodeModal = false

      this.exportMembershipData().then(() => {
        this.getExports({
          params: {
            types: 'export',
          },
        })
      })
    },
  },
}
</script>
